// Port de app/(tabs)/treinamentos.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const TreinamentosScreen = lazy(() => import("@/screens/Treinamentos"));

export default function TreinamentosRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <TreinamentosScreen />
    </Carregando>
  ) : null;
}
